exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read_only[data-v-1a6fc32a]{background-color:#f7f7f7!important;border-color:#f7f7f7!important;color:#262626!important}.accordion .read_only[data-v-1a6fc32a]{background-color:#fcfcfc!important}.read_only[data-v-1a6fc32a]::-moz-placeholder{color:transparent!important}.read_only[data-v-1a6fc32a]::placeholder{color:transparent!important}", ""]);

// exports
